import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TargetRegular from './target-regular-icon.svg';

interface Props {
    color?: string;
}

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <TargetRegular {...validProps} color={props.color} />;
}

SvgComponent.iconName = 'targetRegular';

export const TargetRegularIcon = svgIconWrapper(SvgComponent);
